import React, { useState } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "tss-react/mui";
import { Grid, Typography } from "@mui/material";
import ProductionOverview from "./DataGrids/ProductionOverview/ProductionOverview";
import ProductionByCarrier from "./DataGrids/ProductionByCarrier/ProductionByCarrier";
import "react-table-6/react-table.css";
import ReadyToSellByCarrier from "./ReadyToSellByCarrier/ReadyToSellByCarrier";
import CarrierInformation from "./CarrierInformation";
import ProductionInformation from "./ProductionInformation";
import { Box } from "@mui/system";
import PieChartComponentAgentInfo from "./PieCharts/PieChartComponentAgentInfo";
import RelatedAgenciesComboBox from "./RelatedAgencies/RelatedAgenciesComboBox";

const useStyles = makeStyles()(() => {
  return {
    typography: {
      color: "#003760",
    },
    productionYear: {
      paddingTop: 10,
      fontWeight: 500,
      fontSize: "2em",
    },
  };
});

const AgencyDetail = () => {
  const { classes } = useStyles();
  const [year, setYear] = useState(0);
  const agencyName = sessionStorage.getItem("agencyName");
  const agentTotal = sessionStorage.getItem("agent_total");
  const agencyId = sessionStorage.getItem("agencyId");
  const contracts = useSelector(({ contracts }) => contracts);
  const showRelatedAgencies =
    agencyId != null && agencyId !== "" && agencyId !== 'undefined';
  const directorId = sessionStorage.getItem("directorId");
  const directorName = sessionStorage.getItem("displayName");
  // const unhide = true;

  return (
    <Grid container sx={{ backgroundColor: "#9e9e9e", p: 1, flexGrow: 1 }}>
      <Box
        sx={{ flexGrow: 1, backgroundColor: "#b1bec4", p: 1, borderRadius: 1 }}
      >
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <Typography
              className={classes.typography}
              gutterBottom
              variant="h3"
              component="h2"
            >
              {agencyId !== "undefined" ? agencyName : directorName}
            </Typography>
          </Grid>
          {showRelatedAgencies === true ? (
            <Grid item xs={4}>
              <div style={{ display: "flex", justifyContent: "right" }}>
                <RelatedAgenciesComboBox />
              </div>
            </Grid>
          ) : null}

          <Grid item xs={12}>
            <Typography
              className={
                agencyId
                  ? `${classes.productionYear} ${classes.typography}`
                  : ""
              }
            >
              Summary For PY {year}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <ProductionOverview year={year} agencyId={agencyId} />
          </Grid>
          <Grid item xs={6}>
            <ProductionByCarrier year={year} agencyId={agencyId} />
          </Grid>
          <Grid item xs={6}>
            <ProductionInformation classes={classes} agencyId={agencyId} />
          </Grid>

          <Grid item xs={12}>
            <CarrierInformation
              agencyId={agencyId}
              directorId={directorId}
              classes={classes}
              year={year}
              setYear={setYear}
            />
          </Grid>
          <Grid item xs={6}>
            {contracts.pieData !== undefined ? (
              <PieChartComponentAgentInfo
                agentTotal={agentTotal}
                contracts={contracts}
              />
            ) : null}
          </Grid>
          <Grid item xs={6}>
            <ReadyToSellByCarrier agencyId={agencyId} directorId={directorId} />
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
};

export default AgencyDetail;
